angular.module('env.data.httpInterceptors.omVersionInterceptor', [])

    // Insert owin information about API version into each http request
    .factory('omVersionInterceptor', function ($q) {
        return {
            request: function (request) {
                request.headers = request.headers || {};
                request.headers.OMVersion = om.config.build.omVersion; // API version
                return request || $q.when(request);
            }
        };
    })

;
